<template>
  <div>
    <!-- 快手列表 -->
    <div class="topBox">
      <div class="leftBox">为你找到了<strong>{{pager.total}}</strong>位合适的达人</div>
      <div class="table-head-slot">
        <el-button round size="mini" @click="showCustomDialog">
          <i class="el-icon-setting" style="margin-right: 6px;"></i>自定义列
        </el-button>
        <el-button size="mini" round v-if="isShowCalendar == 1" @click="batchLockHandle"><i class="el-icon-lock" style="margin-right: 6px;"></i>批量锁档</el-button>
        <el-button size="mini" round  @click="onDrCartBatchJoin"><i class="el-icon-shopping-cart-2" style="margin-right: 6px;"></i>批量添加至清单</el-button>
        <el-button size="mini" round @click="exportHandle"><i class="el-icon-upload2" style="margin-right: 6px;"></i>导出</el-button>
      </div>
    </div>
    <div class="ks-table-wrap">
      <div class="my-vxe-table-wrap" v-if="myColumns.length">
        <vxe-table
          v-fixed-table-header
          ref="mainTableRef"
          border="inner"
          class="ks-main-table"
          :row-config="{isHover: true}"
		      :scroll-y="{enabled: true}"
          @cell-dblclick="tableBtnClick"
          align="center"
          :loading = "loading"
          :data="vxeTableData"
          :sort-config="{ remote:true, defaultSort: {field: 'fans', order: 'desc'}}"
          @sort-change="sortChange"
          :row-class-name="rowClassName"
          >
          <vxe-column type="checkbox" width="40" fixed="left"></vxe-column>

          <vxe-column fixed="left" title="达人信息" width="340">
            <template #default="{row}">
              <div class="profile-wrap">
                  <div class="img-wrap">
                    <img class="avatar" :src="row.avatar_uri" v-if="row.avatar_uri" alt="">
                    <img class="avatar" src="./../../../assets/images/avatar.jpg" v-else alt="">
                    <img class="sex" v-if="row.sex" :src="require(`@/assets/${row.sex === '男' ? 'man' : 'woman'}.png`)" alt="" style="width: 20px;height: 20px;" />
                  </div>
                  <div class="info-wrap">
                    <div class="nickname">
                      <img v-if="row?.month_examples_data?.is_hot == '是'" :src="require(`@/assets/images/火爆.png`)" style="margin-right: 4px;">
                      <img v-if="row?.month_examples_data?.is_must == '是'" :src="require(`@/assets/images/必选.png`)" style="margin-right: 4px;">
                      <el-popover trigger="hover">
                        <div class="popover-form">
                          <div class="item">
                            <div class="label">ID</div>
                            <div class="value">{{ row.starid }}</div>
                          </div>
                          <div class="item">
                            <div class="label">账号ID</div>
                            <div class="value">{{ row.uniqueId }}</div>
                          </div>
                          <div v-if="row?.month_examples_data?.reason" class="item">
                            <div class="label">推荐理由</div>
                            <div class="value">{{ row?.month_examples_data?.reason }}</div>
                          </div>
                          <div v-if="row?.is_ban == 1 || row?.is_black == 1 || row?.is_sup_black == 1"  class="item">
                            <div class="label">达人情况说明</div>
                            <div class="value">
                              <span v-if="row?.is_ban == 1">不推荐</span>
                              <span v-else-if="row?.is_black == 1 ">达人已被拉黑</span>
                              <span v-else-if="row?.is_sup_black == 1">归属供应商被拉黑</span>
                            </div>
                          </div>
                          <div v-if="row?.is_ban == 1 || row?.is_black == 1 || row?.is_sup_black == 1" class="item">
                            <div class="label">不推荐理由</div>
                            <div class="value">
                              <template v-if="row?.is_ban == 1 ">
                                {{ row?.ban_data?.reason }}
                              </template>
                              <template v-if="row?.is_black == 1 || row?.is_sup_black == 1 ">
                                {{ row?.black_data?.black_reasons }}
                              </template>
                            </div>
                          </div>
                        </div>
                        <div slot="reference" class="sp-nickname" :class="{'gray-nickname': row?.is_ban == 1 || row?.is_black == 1 || row?.ban_data?.reason}" :title="row.nickname">{{ row.nickname }}</div>
                      </el-popover>
                      <el-tooltip v-if="row.warnTips" placement="top">
                        <div slot="content">
                          {{ row.warnTips }}
                        </div>
                        <i class="el-icon-warning-outline warnTips"></i>
                      </el-tooltip>

                      <img src="@/assets/images/schedule/i-calendar.png" class="i-calendar" v-if="['自孵化号','签约号'].includes(row.logings)" @click="showCalendarDia(row)">
                      <img v-if="row.is_competitive == 1" src="@/assets/images/schedule/排竞.png" class="pj_icon"  @click="showPjModal(row)">
                    </div>
                    <div class="tag-wrap">
                      <SupplierPopover v-if="row.logings" :disabled="!is_product || (!row.logings.includes('合作号') && !row.logings.includes('野生'))" :row="row">
                      </SupplierPopover>
                      <i v-if="row?.month_examples_data?.discount" style="background-color:#e6f8ea;color:#00b42a;">{{row?.month_examples_data?.discount}}折</i>
                      <!-- <i class="special" v-if="row.mcn && (row.mcn === '畅玩文化' || row.mcn.includes('畅玩达人'))" >畅玩达人</i> -->
                    </div>
                    <div class="icon-wrap">
                      <img v-if="row.logings === '签约号' && row.contract_type=='独家'" src="@/assets/images/djdr.png" >
                      <img v-else-if="row.logings === '签约号' && ['非独家，不分商机先后','非独家，优先商机'].includes(row.contract_type)" src="@/assets/images/fdjdr.png" >
                      <img v-else-if="row.logings === '签约号' && row.contract_type=='弱绑定签约达人'" src="@/assets/images/rbddr.png" >
                      <img v-if="row.is_month_examples=='1'" src="@/assets/images/bykl.png" >
                      <el-popover
                        class="pop-special_saletype"
                        v-if="row.special_saletype"
                        placement="top-start"
                        title=""
                        width="200"
                        trigger="hover">
                        <div v-html="row.special_saledesc || '暂无描述'"></div>
                        <img slot="reference" :src="require(`@/assets/images/${row.special_saletype}.png`)"  >
                      </el-popover>
                      <el-tooltip v-if="row.bl_status == '是'" effect="dark" content="该达人支持保量或历史合作项目中有保量案例，具体条款详见合作明细。" placement="top">
                        <img :src="require(`@/assets/images/支持保量.png`)"  >
                      </el-tooltip>
                      <img v-if="row.is_cooling == 1" :src="require(`@/assets/images/冷却.png`)"  >
                      <img v-if="row.isHistorySign" :src="require(`@/assets/images/历史签约号.png`)"  >
                      <el-tooltip v-if="row.isNewSign" effect="dark" content="1、首次入库，成为签约号的前三个自然月。2、非首次入库，从别的账号状态(例如野生)首次改成签约号的前三个自然月。3、非首次入库，从签约号状态改成别的状态(例如野生)再改回签约号的前三个自然月。" placement="top">
      <img :src="require(`@/assets/images/新签约.png`)"  >
    </el-tooltip>
                    </div>
                    <RelatedTalents :row="row"></RelatedTalents>
                    <div class="mechanism">
                      <span :title="row.location">{{ row.location }} | </span>
                      <span style="cursor: pointer;" @mouseenter="showStarChangeHistory($event,row)" @mouseleave="hideStarChangeHistory">机构：{{ row.star || '-' }}</span>
                    </div>
                    <div class="default-order">
                      <!-- <span>内容：<i>{{ row.avg_quality }}</i></span>
                      <span>合作：<i>{{ row.avg_experience }}</i></span>
                      <span>数据：<i>{{ row.avg_effect }}</i></span> -->
                      <!-- 0724 违约商单暂不展示 -->
                      <!-- <span class="txt" v-if="row.error_bussiness_order_num">违约商单：{{ row.error_bussiness_order_num }}</span> -->

                    </div>
                  </div>
              </div>
            </template>
          </vxe-column>

          <vxe-column
            v-for="(item, index) in myColumns"
            :key="item.field"
            :field="item.field"
            :fixed="item.fixed || ''"
            :title="item.title"
            :class-name="item.field.endsWith('_mychart') ? 'chart-wrap' : ''"
            :sortable="item.sortable"
            :titlePrefix="item.titlePrefix"
            :min-width="item.width || 140">
            <template #header v-if="item.titleStr">
              <span v-html="item.titleStr"></span>
            </template>
            <template #default="{column, row}">
              <div v-if="item.formatter && typeof item.formatter == 'function'">{{ item.formatter({cellValue:row[column.field],row,column}) }}</div>
              <div class="bar-cell-wrap" style="width: 100%" v-else-if="column.field.endsWith('_mychart')">
                <el-popover v-if="row[column.field] && row[column.field].hasData" placement="top"
                  title="" width="300" trigger="click">
                    <bar :info="row[column.field]" style="height: 160px; width: 300px"></bar>
                  <p slot="reference" class="p-no-data">{{ row[column.field].firstData || "" }}</p>
                </el-popover>
                <p v-else class="p-no-data">暂无数据</p>
              </div>
              <div class="bar-cell-wrap" style="width: 100%" v-else-if="column.field.includes('devidedrate')">

                <el-popover
                  v-if="row[column.field]"
                  placement="top"
                  title=""
                  width="300"
                  trigger="click">
                  <bar :info="row?.devidedrateChart" style="height: 160px; width: 300px"></bar>
                  <p slot="reference" class="p-no-data" @click="getDevidedrateChart(row.id)">{{ row[column.field] ||"" }}</p>
                </el-popover>
                <p v-else-if="row[column.field]?.length == 0" class="p-no-data">0</p>
                <p v-else class="p-no-data">{{row[column.field]}}</p>
              </div>
              <div v-else-if="column.field == 'accounttype'">
                  <el-popover
                    v-if="row.accounttype && row.accounttype.split"
                    trigger="hover"
                  >
                    <span v-if="row.contenttype" class="popover-tag-wrap">
                      <template v-if="row.contenttype && row.contenttype.split">
                        <i v-for="(tag, tagIdx) in row.contenttype.split(',')" :key="tagIdx">{{ tag }}</i>
                      </template>
                    </span>
                    <span slot="reference">
                        <i class="tag" v-for="(tag, tagIdx) in row.accounttype.split(',')" :key="tagIdx">{{ tag }}</i>
                    </span>
                  </el-popover>
              </div>
              <div v-else-if="column.field == 'segment_labels'">
                <i class="tag" v-for="(tag, tagIdx) in row?.segment_labels?.split(',')" :key="tagIdx">{{ tag }}</i>
              </div>
              <div v-else-if="column.field == 'industry_tags'">
                <i class="tag" v-for="(tag, tagIdx) in row.industry_tags?.split(',')" :key="tagIdx">{{ tag }}</i>
              </div>
              <div class="price_text" v-else-if="column.field.endsWith('_c_count')">
                <el-popover placement="bottom" trigger="click">
                  <div class="table-wrap">
                    <el-table v-if="detailTableData" v-loading="detailTableLoading" height="300" :data="detailTableData" size='small' :header-cell-style="{ background: '#f5f7fa' }">
                      <el-table-column v-for="(item, idx) in detail_field" :key="idx" :fixed="item.fields === 'product' ? 'left' : false"
                        width="150" :sortable="item.ispx ? 'custom' : false" :prop="item.fields" :label="item.name" ></el-table-column>
                      <template #empty>
                        <div class="no-data-wrap">
                          <span>暂无数据</span>
                        </div>
                      </template>
                    </el-table>
                    <el-pagination
                      style="margin-top: 10px;text-align: center;"
                      small
                      background
                      layout="prev, pager, next"
                      :page-size="detailTableLimit"
                      :total="detailTableTotal"
                      :current-page.sync="detailTablePage"
                      @current-change="handleClick(row, column.field)">
                    </el-pagination>
                  </div>
                  <div slot="reference">
                    <div style="color:#606266;font-size: 14px;font-weight: 400;cursor: pointer;" @click="()=>{detailTablePage=1;handleClick(row, column.field)}">
                      {{handleNum(row[column.field], column)}}
                    </div>
                  </div>
                </el-popover>
              </div>
              <div class="price_text" v-else-if="['twentyprice', 'sixtyprice', 'sixtyoverprice', 'price_61', 'price_73', 'price_90', 'price_91'].includes(column.field)">
                <!-- {{handleNum(row[column.field], column)}} -->
                  <el-tooltip v-if="row?.month_examples_data?.is_same_price == '否'" effect="dark" placement="top-start">
                    <template #content>
                      <span>该达人实际接单价格与平台不一致，其他备注说明：{{row?.month_examples_data?.notes}}</span>
                    </template>
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                  <el-popover placement="bottom" trigger="hover">
                    <div>
                      <div style="display: flex;justify-content: space-between;">
                        <!-- <span>1-20s报价</span><span style="color:#FF5C00;">{{row?.twentyprice ?  handleNum(row?.twentyprice, column) : '-'}}</span> -->
                        <span>1-20s报价</span><span style="color:#FF5C00;">{{row?.twentyprice ?  "￥" + (Number(row?.twentyprice.toLocaleString()).toLocaleString()) : '-'}}</span>
                      </div>
                      <div style="display: flex;justify-content: space-between;">
                        <!-- <span>21-60s报价</span><span style="color:#FF5C00;">{{row?.sixtyprice ?  handleNum(row?.sixtyprice, column) :'-'}}</span> -->
                        <span>21-60s报价</span><span style="color:#FF5C00;">{{row?.sixtyprice ? "￥"+(Number(row?.sixtyprice.toLocaleString()).toLocaleString()) : '-'}}</span>
                      </div>
                      <div style="display: flex;justify-content: space-between;">
                        <!-- <span>60s以上报价</span><span style="color:#FF5C00;">{{row?.sixtyoverprice ?  handleNum(row?.sixtyoverprice, column) :'-'}}</span> -->
                        <span>60s以上报价</span><span style="color:#FF5C00;">{{row?.sixtyoverprice ? "￥"+(Number(row?.sixtyoverprice.toLocaleString()).toLocaleString()) : '-'}}</span>
                      </div>
                    </div>
                    <span slot="reference" v-if="row.online_status != 2">
                        <!-- {{row[column.field]? handleNum(row[column.field], column) :'-'}}<i class="el-icon-arrow-down"></i> -->
                      {{row[column.field] ? "￥"+(Number(row[column.field]).toLocaleString()) : '暂无报价'}}<i class="el-icon-arrow-down"></i>
                    </span>
                    <span slot="reference" v-else>
                        <!-- {{row[column.field]? handleNum(row[column.field], column) :'-'}}<i class="el-icon-arrow-down"></i> -->
                      {{'休息'}}<i class="el-icon-arrow-down"></i>
                    </span>
                  </el-popover>
              </div>
              <span v-else>{{ handleNum(row[column.field], column) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="操作" fixed="right" width="190">
            <template #default="scope">
              <div style="display: flex;justify-content: center;flex-wrap: wrap;">
                  <el-dropdown @command="(command)=>handleAddCommand(scope,command)">
                    <span style="width: 30px;">
                      <el-tooltip placement="top" content="添加达人">
                        <img class="rowBtn"  src="@/assets/plus.png" alt="">
                      </el-tooltip>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="add-to-xd">添加至询单</el-dropdown-item>
                      <el-dropdown-item command="add-to-cart">添加至达人清单</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-tooltip placement="top" content="查看快手主页">
                    <img class="rowBtn" @click="onToDrHome(scope)" src="@/assets/home.png" alt="去主页">
                  </el-tooltip>
                  <!-- <el-tooltip placement="top" content="查看代表视频">
                    <img class="rowBtn" @click="onRepresentVideoShow(scope)" src="@/assets/fire.png" alt="">
                  </el-tooltip> -->
                  <el-tooltip placement="top" content="查看达人详情">
                    <img class="rowBtn" @click="tableBtnClick(scope)" src="@/assets/file.png" alt="">
                  </el-tooltip>
                  <el-dropdown @visible-change="handleDrop($event, scope.row)">
                    <span style="cursor: pointer">
                      <img class="rowBtn" src="@/assets/more.png" alt="">
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <template v-if="dropRole.isread || dropRole.isedit">
                        <el-dropdown-item v-if="dropRole.isedit" @click.native.capture="toCrmLibrary(scope, 'add')">媒体库编辑</el-dropdown-item>
                        <el-dropdown-item v-if="dropRole.isread" @click.native.capture="toCrmLibrary(scope, 'detail')">媒体库详情</el-dropdown-item>
                      </template>
                      <el-dropdown-item v-else-if="dropdownLoading">
                          加载中<i class="el-icon-loading"></i>
                      </el-dropdown-item>
                      <el-dropdown-item v-else>
                          无可操作项
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <!-- <img class="rowBtn" @click="showCalculator(scope)" src="@/assets/calc.png" alt=""> -->
              </div>
            </template>
          </vxe-column>
        </vxe-table>
        <vxe-pager background align="right" class="my-list-pager" @page-change="pageChange"
          :current-page.sync="pager.page" :page-size.sync="pager.limit" :page-sizes="[15, 30, 50]" :total="pager.total"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
        </vxe-pager>
      </div>

      <el-dialog title="自定义列" :visible.sync="customDialog.show" class="custom-col-dialog-wrap">
        <el-checkbox-group v-model="customDialog.form.checkList">
          <el-checkbox v-for="(item, index) in baseColumns" :key="index" :label="item.title" style="margin-bottom: 10px">
          </el-checkbox>
        </el-checkbox-group>
        <el-divider></el-divider>
        <el-radio-group v-model="customDialog.form.priceType">
          <el-radio :label="1"> 1-20s报价</el-radio>
          <el-radio :label="2"> 21-60s报价</el-radio>
          <el-radio :label="3"> 60s以上报价</el-radio>
        </el-radio-group>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="customDialog.show = false">取 消</el-button>
          <el-button size="small" type="primary" @click="customDialogConfirm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 自孵化排期 -->
      <Calendar :outerDiaVisible.sync="outerDiaVisible" :info="calendarInfo"></Calendar>
      <!-- 批量锁档 -->
      <ScheduleBatchAddModal ref="ScheduleBatchAddModal"></ScheduleBatchAddModal>

      <DrJoinXdModal :drInfo="currentDrInfo" :show.sync="drJoinShow" />

      <calcDialog :show.sync="calcDialogData.show" :talentInfo="calcDialogData.talentInfo"></calcDialog>

      <div ref="custom_popver" class="custom-popver">
        <vxe-table :data="starChangeHistory">
          <vxe-column field="optdt" title="更新时间" ></vxe-column>
          <vxe-column field="oldval" title="更新前机构" ></vxe-column>
          <vxe-column field="newval" title="更新后机构" ></vxe-column>
        </vxe-table>
      </div>
      <PjModal ref="pjModal" :show.sync="pjModalShow" :id="pjId"></PjModal>
    </div>
  </div>
</template>
<script>
// 快手表格
import * as XLSX from 'xlsx'
export default {
  components: {
    Bar: () => import('@/components/newEchart/Bar.vue'),
    Calendar: () => import("@/components/calendar/calendar.vue"),
    DrJoinXdModal:() => import("../components/DrJoinXdModal.vue"),
    calcDialog: () => import("../components/calcDialog.vue"),
    ScheduleBatchAddModal: () => import("@/pages/kol-list/components/ScheduleBatchAddModal.vue"),
    SupplierPopover: () => import("@/pages/kol-list/components/SupplierPopover.vue"),
    PjModal: () => import("@/pages/kol-list/components/PjModal.vue"),
    RelatedTalents: () => import("@/pages/kol-list/components/RelatedTalents.vue"),
  },
  props: {
    commonQuery: {
      type: Object,
      default: () => {}
    },
    isShowCalendar: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading:false,
      vxeTableData: [],
      query: {},
      baseColumns: [
        { title: '分成税率', field: 'devidedtax', disabled:false, width: 160, sortable: true, fixed: '', },
        { title: '内容分类', field: 'accounttype', disabled:true, width: 160, sortable: false, fixed: '', },
        { title: '畅玩细分标签', field: 'segment_labels', disabled:false, width: 140, sortable: false, fixed: '', titlePrefix: {content: '该达人的畅玩细分标签，若没有你需要的分类，欢迎补充！'}},
        { title: '行业标签', field: 'industry_tags', disabled:false, width: 160, sortable: false, fixed: '', titlePrefix: {content: '根据达人自身商单情况及行业整体情况进行判断达人适合行业'}},

        { title: '粉丝数', field: 'fans', width: 100, sortable: true, fixed: ''},
        { title: '预期播放量', field: 'expectedplay', width: 130, sortable: true, fixed: '', titlePrefix: {content: '基于达人近30天个人作品及聚星作品的播放量预估'}},

        { title: '男粉占比', field: 'i_percent', disabled:false, width: 130, sortable: true, fixed: '', formatter:({ cellValue})=>{ return (cellValue ?? '-') + '%'} },
        { title: '女粉占比', field: 'o_percent', disabled:false, width: 130, sortable: true, fixed: '', formatter:({ cellValue})=>{ return (cellValue ?? '-') + '%'} },
        { title: '粉丝年龄层', field: 'fansagefb', disabled:false, width: 130, sortable: false, fixed: '', formatter:({ row})=>{ return row.fansagefb +(row.fansagefbpct?`\n(${row.fansagefbpct}%)`:'')}},

        { title: '预期CPM', field: 'cpm', width: 120, sortable: true, fixed: '', titlePrefix: {content: '预估每千次播放量的单价(单位：元)'}},
        { title: '互动率', field: 'interact', width: 110, sortable: true, fixed: '', titlePrefix: {content: '达人近30天账号作品被点赞、评论、转发的概率'}},
        { title: '完播率', field: 'playcmt', width: 110, sortable: true, fixed: '', titlePrefix: {content: '达人近30天账号作品被完整播放的概率'}},
        { title: '粉丝增长量', field: 'fans_increment_within_15d', width: 130, sortable: true, fixed: '', titlePrefix: {content: '近30天涨粉量'}},
        { title: '粉丝增长率', field: 'fans_increment_rate_within_15d', width: 130, sortable: true, fixed: '', titlePrefix: {content: '近30天涨粉率'}},

        { title: '真人出镜', field: 'is_real_person', disabled:false, width: 130, sortable: false, fixed: '', formatter:({ row})=>{ return row?.month_examples_data?.is_real_person || '-'}},

        { title: '最新发布时间', field: 'last_video_time', width: 110, sortable: false, fixed: ''},
      ],
      ordertypeList: ['短视频一口价', '信息流授权', '短视频-CPA', '效果类商单-CPS', '短视频生态', '直播生态', '短视频-CPM', '短视频CPM旧', '短视频资源包', '直播带货', '电商CPS产品', '一口价直播', '专场直播', '直播一口价'],
      pager: {
        page: 1,
        limit: 15,
        total: 0
      },
      barData: {
        xAxis: [],
        data: [
          {
            color: '#3F90FD',  // 封装时添加的属性，会添加至itemStyle配置中
            name: '',
            type: 'line',
            smooth: true,
            data: [],
            ...{
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: 'rgba(63, 144, 253, 0.2)' }, // 0% 处的颜色
                    { offset: 1, color: 'rgba(255, 255, 255, 0.01)'} // 100% 处的颜色
                  ],
                  global: false // 缺省为 false
                },
              }
            },  // 传入任何官方支持的配置
          },
        ],
        custom: {
          legend: {show: false},
          yAxis: { show: false },
          xAxis: {
            axisLabel: {
              fontSize: 12,
              rotate: 45,
            }
          },
          grid: {
            left: "5",
            right: "5",
            top: "20%",
            bottom: "5%"
          },
          tooltip: {
            enterable: true,
            appendToBody: true,
            formatter: (params, ticket, cb) => {
              let id = params[0].data.id
              if (this.hoveredChart[id]) {
                if (this.hoveredChart[id].status === 'finished') {
                  return this.handleHoverData(params, this.hoveredChart[id])
                } else {
                  return 'Loading'
                }
              } else {
                this.hoveredChart[id] = {
                  status: 'pending'
                }
                this.getHoverFun(params, ticket, cb)
              }
            }
          },
          series: [
            { itemStyle : { normal: {label: {show: true}}} }
          ]
        },
      },
      sort: 'fans',   // 排序字段
      sortType: 1,  // 0 升序  1：降序
      tableParams: {},
      customDialog: {
        show: false,
        form: {
          checkList: [],
          priceType: 2,
        },
        realForm: {
          checkList: [],
          priceType: 2,
        }
      },
      hide_fields: [],
      checkedData: [],


      outerDiaVisible: false,
      calendarInfo: {},
      hoveredChart: {},

      is_product: false, //是否是产品侧人员权限

      exportFrequency: 0,

      currentDrInfo:{},
      drJoinShow:false,
      calcDialogData: {
        talentInfo: {},
        show: false
      },
      starChangeHistory:[],

      detailTableLoading: false,
      detailTableData: [],
      detailTableTotal: 0,
      detailTablePage: 1,
      detailTableLimit: 15,
      detail_field:[],
      searchOptionsObj: {
        detail_field: [
          {
            fields:"product",
            name:"营销标的",
          },
          {
            fields:"game_type",
            name:"游戏类型",
          },
          {
            fields:"order_num",
            name:"订单单号",
          },
          {
            fields:"ordertype",
            name:"产品类型",
          },
          {
            fields:"ordertype",
            name:"产品名",
          },
          {
            fields:"profit_rate",
            name:"实际利润率",
          },
          {
            fields:"talent_price",
            name:"达人报价",
          },
          {
            fields:"at_total_expenses",
            name:"总支出（税后）",
          },
          {
            fields:"at_expenses",
            name:"实际支付成本税后",
          },
        ],
      },
      pjModalShow: false, // 查看"相关视频"的达人
      pjId:'',
      dropdownLoading: false,
      dropRole: {
        isread: false,
        isedit: false
      }
    }
  },
  computed: {
    myColumns() {
      let columns = this._.cloneDeep(this.baseColumns).filter(x => this.customDialog.realForm.checkList.includes(x.title))
      let selectedOrderType = this.tableParams.order_type || [] // 查询参数选中的产品列表
      let commonList = this._.intersection(selectedOrderType, ['直播生态'])
      // xField和yField用于在获取悬浮数据时取值
      if (commonList.length) {
        commonList.forEach(x => {
          columns.unshift(
            { title: `有效天数(${x})`, field: `${x}_valid_days_mychart`, xField: 'valid_days_time', yField: 'valid_days', width: 150, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作结算数据；排序规则：合作时间降序'} },
            { title: `有效时长(${x})`, field: `${x}_valid_times_mychart`, xField: 'valid_times_time', yField: 'valid_times', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作结算数据；排序规则：合作时间降序'} }
          )
        })
      }
      commonList = this._.intersection(selectedOrderType, ['短视频生态'])
      if (commonList.length) {
        commonList.forEach(x => {
          columns.unshift(
            { title: `发文数(${x})`, field: `${x}_arc_num_mychart`, xField: 'arc_num_time', yField: 'arc_num', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作结算数据；排序规则：合作时间降序'} },
          )
        })
      }
      commonList = this._.intersection(selectedOrderType, ['短视频生态', '短视频-CPM', '短视频CPM旧'])
      if (commonList.length) {
        commonList.forEach(x => {
          let titleTip = x === '短视频生态' ? '数据范围：近半年合作结算数据；排序规则：合作时间降序' : '数据范围：近半年合作数据，图表日期为视频发布日期；排序规则：合作时间降序'
          columns.unshift(
            { title: `播放量(${x})`, field: `${x}_official_settlement_mychart`, xField: 'official_settlement_time', yField: 'official_settlement', width: 300, sortable: false, fixed: '', titlePrefix: {content: titleTip} }
          )
        })
      }
      commonList = this._.intersection(selectedOrderType, ['直播带货', '电商CPS产品'])
      if (commonList.length) {
        commonList.forEach(x => {
          columns.unshift(
            { title: `GMV(${x})`, field: `${x}_final_gmv_mychart`, xField: 'final_gmv_time', yField: 'final_gmv', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作执行完成数据，图表日期为发布日期；排序规则：合作时间降序'} }
          )
        })
      }
      commonList = this._.intersection(selectedOrderType, ['短视频一口价', '信息流授权'])
      if (commonList.length) {
        commonList.forEach(x => {
          let content = x == '短视频一口价' ? '依据合作执行完成数据推荐得出，排序时间依据合作时间降序' : '数据范围：近半年合作执行完成数据，图表日期为视频发布日期；排序规则：合作时间降序'
          let xField = x == '短视频一口价' ? 'mt_profit_time' : 'rebate_rate_time'
          let yField = x == '短视频一口价' ? 'mt_profit' : 'rebate_rate'
          columns.unshift(
            { title: `返点比例(${x})`, titleStr: `<span>返点比例<br>${x}</span>`, field: `${x}_${yField}_mychart`, xField, yField, width: 125, sortable: false, fixed: '', titlePrefix: {content} }
          )
        })
      }
      commonList = this._.intersection(selectedOrderType, ['短视频一口价', '信息流授权', '短视频-CPM', '短视频CPM旧', '短视频资源包', '直播带货', '电商CPS产品', '一口价直播', '专场直播', '直播一口价'])
      if (commonList.length) {
        commonList.forEach(x => {
          columns.unshift(
            { title: `利润率(${x})`, titleStr: `<span>利润率<br>${x}</span>`, field: `${x}_profit_rate_mychart`, xField: 'profit_rate_time', yField: 'profit_rate', width: 125, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作执行完成数据，图表日期为视频发布日期；排序规则：利润率降序'} }
          )
        })
      }
      if (this.customDialog.realForm.priceType == 1) {
        columns.push({ title: '1-20s报价', field: 'twentyprice', width: 140, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 2) {
        columns.push({ title: '21-60s报价', field: 'sixtyprice', width: 140, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 3) {
        columns.push({ title: '60s以上报价', field: 'sixtyoverprice', width: 140, sortable: true, fixed: 'right'})
      }

      // todo 这里不需要求产品交集，选了啥就显示啥的产品次数
      // commonList = this._.intersection(selectedOrderType, this.ordertypeList)
      commonList = [...selectedOrderType]
      if (commonList.length) {  // 有给定产品查看权限的才会有此列
        commonList.forEach(x => {
          columns.splice(0, 0, { title: `合作次数${x}`, titleStr: `<span>合作次数<br>${x}</span>`, field: `${x}_c_count`, width: 125, sortable: false, fixed: ''})
        })
        if (commonList.length >= 2) {
          columns.splice(0, 0, { title: `合作次数(总)`, titleStr: `<span>合作次数<br>(总)</span>`, field: `c_count`, width: 125, sortable: false, fixed: ''})
        }
      }

      if(!this.query.logings?.includes('签约号')){
        //'分成税率' 只有签约号才显示
        const index = columns.findIndex(item => item.field === 'devidedtax')
        if(index != -1){
          columns.splice(index, 1)
        }
      }

      return columns
    },
    // isCanExport() {
    //   // 产品侧&&当日导出未超过10次
    //   return localStorage.getItem('uid') == 1 || (this.is_product && +this.exportFrequency < 10)

    // }
  },
  watch: {
    commonQuery: {
      deep: true,
      handler(val, oldVal) {
        this.pager.page = 1
        this.query = this._.cloneDeep(val) || {}
        setTimeout(() => {
          this.getMyTable()
        }, 0);
      },
    },
    'commonQuery.product_logings'(val, oldVal){
      if (val == '签约号') {
        // 如果选择签约号，则优先按 独家达人 排序
        this.$refs.mainTableRef.clearSort(this.sort)
        this.sort = 'contract_type'
        this.sortType = 1
      }
    },
    '$store.state.is_product': {
      handler(val){
        this.is_product = val
      },
      immediate: true
    }
  },
  created() {
    this.hide_fields = JSON.parse(localStorage.getItem("ks_hide_fields") || JSON.stringify([]))
    if(!this.hide_fields.includes("devidedrate")) {
      this.baseColumns.unshift({ title: '媒体侧自然返点', titleStr: `<span>媒体侧自然返点</span>`, field: 'devidedrate', width: 180, sortable: true, fixed: '', titlePrefix: {content: '签约号和自孵化号以运营填写的建议返点比例%为准，合作号/野生优先展示短视频一口价产品的建议返点比例。'}})
    }
    let checkList = JSON.parse(localStorage.getItem("ksCheckList") || JSON.stringify([]))
    this.customDialog.form.checkList = checkList.length ? checkList : this.baseColumns.map(x => x.title)
    this.customDialog.realForm.checkList = checkList.length ? checkList : this.baseColumns.map(x => x.title)


    let priceType = JSON.parse(localStorage.getItem("ksPriceType")) || 2
    this.customDialog.form.priceType = priceType
    this.customDialog.realForm.priceType = priceType
  },
  methods: {
    showPjModal(row){
      this.pjModalShow = true
      this.pjId = row.id
    },
    getDevidedrateChart(id){
      this.$axios.get(`/api.php?m=index|api|gx&a=getTalentMap&lid=${id}`, {headers: { showLoading: false }}).then(res => {
        let {devidedrate= [],devidedrate_time=[]} = res
        console.log('res :>> ', res);
        let chartMap = {}
        let baseChart = this._.cloneDeep(this.barData)
            baseChart.xAxis = (devidedrate_time|| []).map(x => this.dayjs(x).format('MM-DD'))
            baseChart.data[0].data = (devidedrate || [])
            baseChart.data[0].name = "媒体侧自然返点"
            // 判断是否有data数据 没有data数据的话 就不渲染图表
            baseChart.hasData = baseChart.data[0].data?.length > 0
            baseChart.firstData = baseChart.data[0].data?.[0]?.value || ""
            chartMap.devidedrateChart = baseChart
            // let id = 0
            let idx = this.vxeTableData.findIndex(y => y.id == id)
            this.vxeTableData.splice(idx, 1, {
                ...this.vxeTableData[idx],
                ...chartMap
              })
      })
    },
    rowClassName({row}){
      if(row?.is_black == 1 || row?.is_sup_black == 1){
        return 'gray-color'
      }else if (row?.is_ban == 1 || row?.ban_data?.reason){
        return 'ban-color'
      }
    },
    getMyTable() {
      let params = this.handleQuery()
      let {main, other = ''} = params
      let {page, limit: page_size} = this.pager

      // 如果选择签约号，则优先按 独家达人 排序
      if (params.main.product_logings == '签约号' && !this.sort) {
        this.sort = 'contract_type'
        this.sortType = 1
      }

      params = {
        ...main,
        page,
        page_size,
        sort: this.sort,
        sort_type: this.sortType,
        plat: 2
      }
      let newQuery = {}
      Object.keys(params).forEach(x => {
        if(x.startsWith('price_')) {
          let keyName = x.split('_')[1]
          const keyMap = {
            1: 'price_20',
            2: 'price',
            3: 'price_999',
          }
          newQuery[`${keyMap[this.customDialog.realForm.priceType]}_${keyName}`] = params[x]
        }else {
          newQuery[x] = params[x]
        }
      })

      params = newQuery
      this.tableParams = this._.cloneDeep(params)
      let url = `/api.php?m=index|api|gx&a=search`
      if (other) {
        url += `&${other}`
      }
      this.loading = true
      this.$axios.get(url, {params, headers: { showLoading: false }, }).then(res => {
        this.loading = false
        let {list = [], page_info = {}, stats = {}} = res || {}
        let ids = []
        // 3个月前的日期节点
        const newSignDateFlag = this.dayjs().subtract(3, 'month')
        list.forEach(x => {
          ids.push(x.id)
          x.avg_quality = x.avg_quality ? Math.round(+x.avg_quality) : 0
          x.avg_experience = x.avg_experience ? Math.round(+x.avg_experience) : 0
          x.avg_effect = x.avg_effect ? Math.round(+x.avg_effect) : 0
          x.industry_tags = [...new Set(x.industry_tags?.split(',')?.map(item=>item.split('-')[0]))]?.join(',')
          x.special_saletype = x.special_saletype?.split(',')?.filter(item => item !== '促销' && item)?.[0]

          // 历史签约号
          x.isHistorySign = x.logings !== '签约号' && x.has_sign == 1
          // 新签约号，当前是签约号，并且签约时间在3个月内
          x.isNewSign = x.logings == '签约号' && newSignDateFlag.isBefore(x.last_sign_time)
        })
        this.vxeTableData = list
        if(window.scrollY > 600) {
          this.$nextTick(() => {
            window.scrollTo({
              top: 600,
              behavior: 'smooth'
            })
          })
        }
        this.getChart(ids.join())
        this.pager.total = page_info.total * 1
        this.exportFrequency = stats.export
      }).finally(() => {
        this.loading = false
      })
      // 世明那边的埋点
      this.$api.setUserTimeLog()
    },
    handleQuery() {
      // 这个方法会特殊处理韬哥给的options的value为 “xxxxxx=20%”的
      let keyList = ['content_form', 'fans_age', 'fans_cities', 'fans_grenders', 'fans_systems', 'watcher_age', 'watcher_cities',
        'watcher_grenders', 'watcher_systems', 'styleValue', 'devidedrate', 'devidedrate_ge' ]
      let other = [], copyQuery = this._.cloneDeep(this.query)
      keyList.forEach(x => {
        if (copyQuery[x]) {
          if(copyQuery[x] instanceof Array) {
            copyQuery[x]?.forEach(_x => {
              other.push(_x)
            })
          }else {
            other.push(copyQuery[x])
          }
          delete copyQuery[x]
        }
      })

      copyQuery.last_video_time_type = copyQuery.last_video_time_type ? 'month' : ''

      return {
        main: copyQuery,
        other: other.join('&')
      }
    },
    sortChange(args) {
      let { property, order } = args
      this.sort = order ? property : ''
      this.sortType = order === 'desc' || !order ? 1 : 0
      this.pager.page = 1
      this.getMyTable()
    },
    batchLockHandle() {
      const checkedData = this.$refs.mainTableRef?.getCheckboxRecords()
      this.$refs.ScheduleBatchAddModal.show(checkedData)
    },
    showCustomDialog() {
      this.customDialog.form = this._.cloneDeep(this.customDialog.realForm)
      this.customDialog.show = true
    },
    tableBtnClick({row}) {
      LA.track('ks_short_video_talentinfo');
      let routeData = this.$router.resolve({
        path: '/ks',
        query: {
          id: row.starid,
          logings: row.logings,
          shortid: row.shortid,
          mid:row.id,
        }
      })
      window.open(routeData.href, "_blank");

      // 详情页浏览频率埋点
      let logParams = {
        type: 4,
        plat: 2,
        shortid: row.shortid || "",
        starid: row.starid || ""
      }
      this.$api.setUseLog(logParams)
    },
    pageChange({ type, currentPage, pageSize }) {
      if (type == 'size') {
        this.pager.page = 1
      }
      this.getMyTable()
    },
    handleHoverData(params, data = {}) {
      let title = ""
      let content = ""
      if(params[0].seriesName == "媒体侧自然返点"){
        title = `<span style="font-size: 14px; font-weight: bold; color: #333; margin-bottom: 20px">${params[0].name}</span>`
        content = `
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>更新时间：</span>
            <span style="font-weight: bold;">${data.optdt|| ''}</span>
          </div>
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>更新前比例：</span>
            <span style="font-weight: bold;">${data.oldval || ''}</span>
          </div>
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>更新后比例：</span>
            <span style="font-weight: bold;">${data.newval || ''}</span>
          </div>
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>数据源：</span>
            <span style="font-weight: bold;">${data.optname || ''}</span>
          </div>
        `
      }else{
        title = `<span style="font-size: 14px; font-weight: bold; color: #333; margin-bottom: 20px">${params[0].name}</span>`
        content = `
        <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
          <span>订单号：</span>
          <span style="font-weight: bold;">${data.order_num || ''}</span>
        </div>
        <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
          <span>${params[0].seriesName}：</span>
          <span style="font-weight: bold;">${params[0].value || ''}</span>
        </div>
      `
      if (data.supplier_name && data.supplier_name !== '无') {
        content += `
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>供应商：</span>
            <span style="font-weight: bold;">${data.supplier_name}</span>
          </div>
        `
      }
      content += `
        <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
          <span>客户：</span>
          <span style="font-weight: bold;">${data.cust_name || ''}</span>
        </div>
        <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
          <span>营销标的：</span>
          <span style="font-weight: bold;">${data.product || ''}</span>
        </div>`
      }
      return title + content
    },
    getHoverFun(params, ticket, cb){
      let id = params[0].data.id || ''
      let a = params[0].seriesName == "媒体侧自然返点" ? 'getTalentMapDetail' : 'getMapDetail'
      this.$axios.get(`/api.php?m=index|api|gx&a=${a}&cid=${id}`, {
        headers: { showLoading: false },
      }).then(res => {
        this.hoveredChart[id] = {
          status: 'finished',
          ...res
        }
        cb(ticket, this.handleHoverData(params, res || {}))
      }).catch(res => {
        this.hoveredChart[id].status = ''
      })
    },
    getChart(ids) {
      let order_type = this.tableParams.order_type || []
      this.$axios.get(`/api.php?m=index|api|gx&a=getTalentOrderMap&lids=${ids}&order_type=${order_type.join()}`, {headers: { showLoading: false }}).then(res => {
        let {list = {}, bad_review_list = []} = res
        for (const key in list) {
          list[key]?.forEach(x => {
            let idx = this.vxeTableData.findIndex(y => y.id == x.mid)
            if (idx !== -1) {
              let chartMap = {}
              let countMap = {}
              this.myColumns.forEach(y => {
                if (y.field.endsWith('_mychart')) {
                  let baseChart = this._.cloneDeep(this.barData)
                  baseChart.xAxis = (x[y.xField] || []).map(x => this.dayjs(x).format('MM-DD'))
                  baseChart.data[0].data = (x[y.yField] || [])
                  baseChart.data[0].name = y.title
                  // 判断是否有data数据 没有data数据的话 就不渲染图表
                  baseChart.hasData = baseChart.data[0].data?.length > 0
                  baseChart.firstData = baseChart.data[0].data?.[0]?.value || ""
                  chartMap[y.field] = baseChart
                } else if (y.field.endsWith('_c_count') && y.field?.split('_')?.[0] == key) {  // 各产品合作次数
                  countMap[y.field] = x?.total_count ? x?.total_count : 0
                }
              })
              this.vxeTableData.splice(idx, 1, {
                ...this.vxeTableData[idx],
                ...countMap,
                ...chartMap
              })
            }
          })
        }
        bad_review_list.forEach(x => {
          let idx = this.vxeTableData.findIndex(y => y.id == x.mid)
          if (idx !== -1) {
            this.$set(this.vxeTableData[idx],'warnTips','近180天有合作不满意记录')
          }
        })
      })
    },
    handleNum(value, column) {
      if (['twentyprice', 'sixtyprice', 'sixtyoverprice'].includes(column.field)) {
        if (value) {
          // return `¥${this.fmt(value, {micrometer: true})}`
          return `¥${Number(value).toLocaleString()}`
        } else {
          return '-'
        }
      }
      if (column.title.endsWith('率')) {
        return value ? `${this.fmt(value)}%` : '0%'
      } else {
        return this.fmt(value, {micrometer: true}) || 0
      }
    },
    customDialogConfirm() {
      this.customDialog.realForm = this._.cloneDeep(this.customDialog.form)
      localStorage.setItem("ksCheckList", JSON.stringify(this.customDialog.realForm.checkList));
      localStorage.setItem("ksPriceType", JSON.stringify(this.customDialog.realForm.priceType));
      this.customDialog.show = false
      this.getMyTable()
    },
    showCalendarDia(item) {
      this.calendarInfo = {
        plat: '快手',
        shortid: item.shortid,
        starid: item.starid || ""
      }
      this.outerDiaVisible = true
    },

    exportHandle() {
      let checkedData = this.$refs.mainTableRef?.getCheckboxRecords()
      if(!checkedData.length && localStorage.getItem('uid') != 1) {
        this.$message.warning(`请勾选要导出的达人！`)
        return
      }

      // if(localStorage.getItem('uid') != 1 && checkedData.length > 30) {
      //   this.$message.warning(`每次最多可导30个达人！`)
      //   return
      // }

      let params = {
        page: 1,
        page_size: 10000,
        search_type: 'export',
        shortids: checkedData.map(x => x.shortid).filter(x => x).join(),
        plat: 2
      }

      let url = `/api.php?m=index|api|gx&a=search`
      if(!checkedData.length && localStorage.getItem('uid') == 1) {
        let specialParams = this.handleQuery()
        let {main, other = ''} = specialParams
        if (other) {
          url += `&${other}`
        }
        params = {
          ...this.tableParams,
          page: 1,
          page_size: 10000,
          search_type: 'export',
          plat: 2
        }
      }
      this.loading = true
      this.$axios.get(url, { params , headers: { showLoading: false }, }).then(res => {
        this.loading = false
        let {list = [], stats = {}} = res || {}
        this.exportFrequency = stats.export
        if(!list.length) {
          this.$message.warning(`没有需要导出的数据！`)
        }else {
          let fileds = ['accounttype', 'contenttype', 'nickname', 'uniqueid', 'shortid', 'homepage', 'fans', 'i_percent', 'fans_age_pct_1', 'fans_age_pct_2', 'fans_age_pct_3', 'avg_play5', 'sd_avg_play5', 'twentyprice', 'sixtyprice', 'sixtyoverprice', 'cpm', 'expectedplay']
          let titles = ['一级分类', '二级分类', '昵称', '账号ID', 'UID', '主页链接', '粉丝量（W）', '男粉占比', '18-23岁年龄层粉丝占比', '24-30岁年龄层粉丝占比', '31-40岁年龄层粉丝占比', '近5个日常视频平均播放量（W）', '近5个商单视频平均播放量（W）', '1-20报价', '21-60报价', '60+报价', '预期CPM', '近30天播放量']
          let data = list.map(x => {
            let cur = []
            fileds.forEach(field => {
              let result = {}
              if(['avg_play5', 'sd_avg_play5', 'expectedplay'].includes(field)){
              result = this.fmt(x[field], { micrometer: true })
              }else if (['fans'].includes(field)){
                  result = this.fmt(x[field]/10000, { micrometer: true })
              }else{
                  result = x[field]
              }
              cur.push(result)
            })
            return cur
          })

          const ws = XLSX.utils.aoa_to_sheet([titles, ...data]);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
          XLSX.writeFile(wb, `快手达人.xlsx`);
          this.$message.success(`已为您导出${list.length}条达人数据`)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onDrJoin({row}){
      // 将达人添加到询单埋点
      this.$api.setUseLog({
        type: 31,
        plat: 2,
        shortid: row.shortid || "",
        starid: row.starid || ""
      })
      if(row?.is_ban == 1 || row?.is_black == 1 || row?.is_sup_black == 1 ){
        this.$modal.message({status: 'warning', content: '该达人已被拉黑，无法加入询单~'})
        return
      }
      this.currentDrInfo = row
      this.drJoinShow = true
    },
    showCalculator({row}) {
      this.calcDialogData = {
        show: true,
        talentInfo: {
          nickName: row.nickname
        }
      }
    },
    async showStarChangeHistory(event,row){
      if (!row?._starChangeHistory) {
        const data = await this.$axios.get('api.php?m=index|api|gx&a=talentSupLog', {
          params:{
            mid: row.id
          },
          headers: { showLoading: false },
        })
        this.$set(row,'_starChangeHistory',data )
      }
      this.starChangeHistory = row._starChangeHistory
      if (!this.starChangeHistory.length) {
        return
      }
      setTimeout(()=>{
        const contentRect = this.$refs.custom_popver.getBoundingClientRect()
        const rect = event.target.getBoundingClientRect()
        let top = rect.bottom - contentRect.height/2,left = rect.right + 4
        if(top + contentRect.height > innerHeight ) {
          top = innerHeight - contentRect.height - 10
        }
        this.$refs.custom_popver.style.top= top + 'px'
        this.$refs.custom_popver.style.left= left + 'px'
        this.$refs.custom_popver.classList.add('show')
        addEventListener("scroll", this.hideStarChangeHistory, { once: true })
      },0)

    },
    hideStarChangeHistory(){
      this.$refs.custom_popver.classList.remove('show')
      removeEventListener("scroll", this.hideStarChangeHistory)
    },

    handleAddCommand(scope,command){
      switch (command) {
        case 'add-to-xd':
          this.onDrJoin(scope)
          break;
        case 'add-to-cart':
          this.onDrCartJoin(scope)
          break;
      }
    },
    // 去主页
    onToDrHome(scope){
      const url = `https://live.kuaishou.com/profile/${scope.row.secuid}`
      window.open(url)
    },
    async onDrCartJoin({row}){
      const data = await this.$axios.get('api.php?m=cart|api|gx&a=add', {
        params:{
          lid: row.id,
          plat: '快手'
        },
        headers: { showLoading: false },
      })
      this.$message.success('添加成功')
      this.$store.dispatch('shoppingCart/refreshCount')
    },
    async onDrCartBatchJoin(){
      const rows = this.$refs.mainTableRef?.getCheckboxRecords()
      if (!rows.length) {
        this.$modal.message({status: 'warning', content: '请先选择达人'})
        return
      }
      const data = await this.$axios.get('api.php?m=cart|api|gx&a=batchAdd', {
        params:{
          lids: rows.map(row => row.id).join(','),
          plat: '快手'
        },
        headers: { showLoading: false },
      })
      this.$message.success('添加成功')
      this.$store.dispatch('shoppingCart/refreshCount')
    },
    handleClick(row,field){
      console.log('this.plat :>> ', this.plat);
      console.log('field :>> ', field);
      console.log('row :>> ', row);
      let order_type = field?.split("_c_count")?.[0] || ''
      if(order_type == "一口价直播" || order_type == "一口价直播（框架资源包）"){
        this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
          if(["订单单号","游戏类型","产品类型","营销标的","达人报价","实际利润率"].includes(x.name)){
            return x
          }
        })
      } else if(order_type == "直播-CPA"){
        this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
          if(["订单单号","营销标的","达人报价","实际利润率"].includes(x.name)){
            return x
          }
        })
      } else if(order_type == "短视频生态"  ){
        this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
          if(["订单单号","产品名","营销标的","总支出（税后）"].includes(x.name)){
            return x
          }
        })
      } else if(order_type == "直播生态"){
        this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
          if(["订单单号","产品名","营销标的","总支出（税后）","实际支付成本税后"].includes(x.name)){
            return x
          }
        })
      } else {
          this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
            if(["订单单号","产品类型","营销标的"].includes(x.name)){
              return x
            }
          })
      }
      let params = {
        order_type,
        plat: "快手",
        page: this.detailTablePage,
        limit: this.detailTableLimit,
        shortid: row.shortid,
      }
      this.detailTableLoading = true
      this.$axios.post('/api.php?m=case|api|gx&a=drcaselist', params, {headers: { showLoading: false}}).then(res => {
        let {rows = [], totalCount = 0} = res || {}
        this.detailTableTotal = totalCount
        this.detailTableData = rows
      }).catch( err => {})
      .finally(() => {
        this.detailTableLoading = false
      })

    },
    toCrmLibrary({row}, type) {
      let origin = location.origin.includes('test') ? 'http://test.erp.changwankeji.com:8080' : 'https://erp.changwankeji.com:8188'
      let url = `${origin}/dist/index.html#/crmlibrary/${type}?id=${row.id}`
      window.open(url)
    },
    async handleDrop(flag, row){
      if(!flag){
        this.dropRole = {
          isread: false,
          isedit: false
        }
        return
      }
      this.dropdownLoading = true
      this.$axios.get(`/api.php?m=detail|api|gx&a=getAuth&lid=${row.id}`,{headers: { showLoading: false }}).then(async res => {
        this.dropRole = res || {}
      }).finally(() => {
        this.dropdownLoading = false
      })
    },
  }
}
</script>
<style scoped lang="less">
@import url('../../../assets/css/table-style.less');
.pj_icon{
    width: 20px;
    height: 20px;
    margin-left: 5px;
    cursor: pointer
  }
// 自定义弹窗
.custom-popver{
  position: fixed;
  visibility: hidden;
  background-color: #fff;
  color: #333;
  text-align: left;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 1000;
  width: 470px;
  box-sizing: border-box;
}
.custom-popver.show{
  visibility:visible;
}

.img-wrap{
    position: relative;
    .sex{
      position: absolute;
      right: 10px;
      bottom: 0px;
    }
  }
  .tag{
    display: inline-block;
    border-radius: 2px;
    background: #F6F6F6;
    color: #333333;
    padding: 2px 4px;
    margin-bottom: 4px;
  }
  .tag+.tag{
    margin-left: 4px;
  }
  .gray-nickname{
    color: #A9AEB8;
  }
</style>